import React, { useState } from 'react'

import { PlusOutlined, QuestionCircleFilled } from '@ant-design/icons'
import ListPageHeader from '@shared/ListPageHeader'
import InventoryMonitorsList from '@shared/inventory_monitors/InventoryMonitorsList'
import InventoryMonitorConceptModal from '@shared/inventory_monitors/InventoryMonitorConceptModal'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { inventoryMonitorService } from '@services/admin/inventoryMonitorService'
import { inventoryTypeService } from '@services/admin/inventoryTypeService'

export default function AdminInventoryMonitorsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [conceptVisible, setConceptVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.trackers']}
        guideButton={
          <Tooltip title={t('concepts.inventory_monitors.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/inventory_monitors/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <InventoryMonitorsList
        service={inventoryMonitorService}
        inventoryTypeService={inventoryTypeService}
        role="admin"
      />
      <InventoryMonitorConceptModal
        visible={conceptVisible}
        onClose={() => setConceptVisible(false)}
      />
    </div>
  )
}
